// extracted by mini-css-extract-plugin
export default {"title":"user_title__W78EM","drawer":"user_drawer__+jEVO"};